import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { setNFBottomOperatorBar } from '@/utils/tools'


export default /*#__PURE__*/_defineComponent({
  __name: 'common-redirect-page',
  setup(__props) {

// 可用于在webview中承接打开第三方网页需要设置app相关配置时，如设置非沉浸式

const { setBottomHandle } = setNFBottomOperatorBar()
const $route = useRoute()

const url = decodeURIComponent($route.query.url as string)
console.log('url', url)

setBottomHandle()

onMounted(() => {
  if (!url) {
    return
  }
  window.location.replace(url)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})